








































































import { QVueGlobals } from 'quasar';
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import LayerSelector from '@/components/LayerSelector.vue';
import SearchContainer from '@/components/SearchContainer.vue';
import Map from '@/views/Map.vue';
import EsriPrint from '@/components/EsriPrint.vue';
import EsriSketch from '@/components/EsriSketch.vue';

@Component({
  components: {
      LayerSelector,
      SearchContainer,
      Map,
      EsriPrint,
      EsriSketch,
    },
})
export default class LayoutDefault extends Vue {

  public layerMenuShowing = false;

  get leftDrawerOpen() {
    return this.$store.state.leftDrawerOpen;
  }

  get rightDrawerOpen() {
    return this.$store.state.rightDrawerOpen;
  }

  get sketchVisible() {
    return this.$store.state.sketch;
  }

  get editLayer() {
    return this.$store.state.edit.layer;
  }

  public unsubscribe = this.$store.subscribeAction((action, state) => {
      if (action.type === 'notify') {
          this.notify(action.payload);
      }
  });

  public notify(message: any) {
    this.$q.notify(message);
  }

  public mounted() {
    console.log('App: mounted()');
  }

  public onAbout() {
    this.$store.dispatch('aboutAction');
  }

  public drawerToggleLeft(content: string) {
    this.$store.dispatch('drawerToggleLeft', content);
  }

  public drawerToggleRight(content: string) {
    this.$store.dispatch('drawerToggleRight', content);
  }

  public sketchToggle() {
    this.$store.dispatch('sketchToggle');
  }

  public clearDrawing() {
    this.$store.dispatch('clearDrawing');
  }
}
